export default __webpack_public_path__ + "static/media/AlgoLogo_Ocho.bfccbd26.png";